import { ChevronDown, CursorBox, List } from "@untitledui/icons";
import { Button } from "@/components/base/buttons/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import type { ActionType } from "@/lib/assurance/action-types";
import { LogActionMenuItems, TakeActionMenuItems } from "./action-menu-items";

interface ActionDropdownProps {
  onSelectAction: (actionType: ActionType, category: "take" | "log") => void;
  disabled?: boolean;
}

export const TakeActionDropdown = ({ onSelectAction, disabled }: ActionDropdownProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <Button
          isDisabled={disabled}
          iconLeading={<CursorBox className="w-4 h-4" />}
          iconTrailing={<ChevronDown className="w-4 h-4" />}
        >
          Action risks
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={8}>
        <TakeActionMenuItems onSelectAction={onSelectAction} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export const LogActionDropdown = ({ onSelectAction, disabled }: ActionDropdownProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <Button
          isDisabled={disabled}
          iconLeading={<List className="w-4 h-4" />}
          iconTrailing={<ChevronDown className="w-4 h-4" />}
        >
          Log action
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={8}>
        <LogActionMenuItems onSelectAction={onSelectAction} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
